import { Grid, TextField, Box, Stack, Chip, Button } from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { HelperTextComponent } from "../common/HelperTextComponent";

export const AddDrug = (props: any) => {
  const { register, watch, setValue, isEdit, studyData } = props;
  const [treatments, setTreatments] = useState<any>(
    isEdit ? studyData?.treatments : []
  );
  const [drugName, setDrugName] = useState<string>("");
  const handleAddDrug = () => {
    setTreatments([...treatments, drugName?.trim()]);
    setDrugName("");
  };

  const handleDeleteChip = (id: number) => {
    setTreatments(
      treatments.filter((item: any, index: number) => index !== id)
    );
  };
  const watchTreatments = watch("treatments");

  useEffect(() => {
    setValue("treatments", treatments);
  }, [watchTreatments, register]);
  return (
    <Grid container columnSpacing={3} className="mt2">
      <Grid
        item
        xs
        sx={{
          maxWidth: "calc(100% - 152px) !important",
        }}
      >
        <TextField
          fullWidth
          label="Treatment"
          type="text"
          value={drugName}
          variant="standard"
          onChange={(e) => {
            setDrugName(e.target.value);
          }}
          inputProps={{ maxLength: 100 }}
          helperText={
            drugName?.length === 100 && <HelperTextComponent mlength="100" />
          }
          id="add-drug"
        />
        <input
          type="hidden"
          value={treatments}
          {...register("treatments", { value: treatments })}
        />
        <Stack
          direction="row"
          rowGap={1}
          columnGap={1}
          my={1}
          className="flexWrap"
        >
          {treatments.length > 0 &&
            treatments?.map((item: any, index: any) => {
              return (
                <Chip
                  size="small"
                  label={item}
                  variant="outlined"
                  color="primary"
                  onDelete={() => handleDeleteChip(index)}
                  key={index}
                  id={`drug-${index + 1}`}
                />
              );
            })}
        </Stack>
      </Grid>
      <Grid item>
        <Box className="mt1">
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            onClick={() => handleAddDrug()}
            disabled={drugName?.trim()?.length == 0}
            id="add_drug_button"
          >
            Add Drug
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};
